module.exports = __webpack_public_path__ + "static/media/eight.0d9f74a4.svg";